/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCertificatePath = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 20v2H5v-2zm5-9a4 4 0 0 1 3.001 6.645L21 22h-6v-4.354A4 4 0 0 1 18 11zm1 7.874c-.172.044-.35.078-.531.099-.007 0-.014 0-.02.002A3.387 3.387 0 0 1 18 19l.224-.006a4.065 4.065 0 0 1-.448 0l-.022-.002a3.803 3.803 0 0 1-.203-.017l-.02-.003a3.876 3.876 0 0 1-.53-.098L17 20h2zM18 13a2 2 0 0 0-1.476 3.35l.144.128a1.996 1.996 0 0 0 1.16.515L18 17a1.945 1.945 0 0 0 .205-.01l-.034.002a1.98 1.98 0 0 0 1.16-.514l.145-.128A2 2 0 0 0 18 13zM16.707 1.293 20.414 5l-3.707 3.707-1.414-1.414L16.585 6H7a3 3 0 0 0-.176 5.995L7 12h6v2H7a5 5 0 0 1-.217-9.995L7 4h9.585l-1.292-1.293z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCertificatePath as CertificatePath };
